import React, { useRef, useState } from "react";
import { login } from "../../components/imagepath";
import { Link } from "react-router-dom";
import FeatherIcon from "feather-icons-react/build/FeatherIcon";
import { Eye, EyeOff } from "react-feather/dist";
import { Select } from "antd";
import { hooks } from "../../studentportal-sdk";
import { useForm, Controller } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { availableRegions, registerSchema } from "../../constant";

const Register = (props) => {
  const [passwordVisible, setPasswordVisible] = useState(false);
  const [password, setPassword] = useState("");

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  const {
    /**
     * authentication service
     */
    authService: {
      action: { userAccountSignUp },
    },
    /**
     * utility and config service
     */
    utilityAndConfigService: {
      store: { loading, message },
    },
  } = props;

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(registerSchema),
  });

  const onSubmit = (data) => {
    userAccountSignUp(data);
  };
  return (
    <>
      {/* Main Wrapper */}
      <div className="main-wrapper login-body">
        <div className="login-wrapper">
          <div className="container">
            <div className="loginbox">
              <div className="login-left">
                {/* <img className="img-fluid" src={login} alt="Logo" /> */}
              </div>
              <div className="login-right">
                <div className="login-right-wrap">
                  <h1>Register </h1>
                  <p className="account-subtitle">
                    Enter details to create your account
                  </p>
                  {/* Form */}
                  <form onSubmit={handleSubmit(onSubmit)}>
                    <div className="form-group">
                      <label>
                        First Name <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="firstname"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className={`form-control  ${
                                errors?.firstname ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                            <span className="profile-views">
                              <i className="fas fa-user-circle" />
                            </span>
                          </>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.firstname?.message}</small>
                    </div>
                    <div className="form-group">
                      <label>
                        Last Name <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="lastname"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className={`form-control  ${
                                errors?.lastname ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                            <span className="profile-views">
                              <i className="fas fa-user-circle" />
                            </span>
                          </>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.lastname?.message}</small>
                    </div>
                    <div className="form-group">
                      <label>
                        Phone Number <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="phone"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className={`form-control  ${
                                errors?.phone ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                            <span className="profile-views">
                              <i className="fas fa-phone" />
                            </span>
                          </>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.phone?.message}</small>
                    </div>
                    {/* <div className="form-group">
                      <label>
                        Username <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="username"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className={`form-control  ${
                                errors?.username ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                            <span className="profile-views">
                              <i className="fas fa-phone" />
                            </span>
                          </>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.username?.message}</small>
                    </div> */}
                    <div className="form-group">
                      <label>
                        Email <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="email"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <input
                              className={`form-control  ${
                                errors?.email ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                              autoComplete="false"
                            />
                            <span className="profile-views">
                              <i className="fas fa-envelope" />
                            </span>
                          </>
                        )}
                        defaultValue="johndoe@gmail.com"
                      />
                      <small>{errors?.email?.message}</small>
                    </div>
                    
                    <div className="form-group">
                    <label>
                              Group <span className="login-danger">*</span>
                            </label>
                            <Controller
                              name="group"
                              control={control}
                              render={({ field: { value, onChange } }) => (
                                <>
                                 <select
                              className={`form-control ${
                                errors?.category ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                            >
                              <option className="form-control" value="">Select Group</option>
                              {availableRegions.map((region) => <option className="form-control" value={region}>{region}</option>)}
                              </select>
                                </>
                              )}
                              defaultValue=""
                            />
                            <small>{errors?.group?.message}</small>
                    </div>
                    <div className="form-group">
                      <label>
                        Leadership Category{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="category"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <>
                            <select
                              className={`form-control ${
                                errors?.category ? "error-input" : ""
                              }`}
                              type="text"
                              value={value}
                              onChange={onChange}
                            >
                              <option className="form-control" value="">Select Category</option>
                              <option className="form-control" value="Cell Leader">Cell Leader</option>
                              <option className="form-control" value="Code Rabah Cell Leader">
                                Code Rabah Cell Leader
                              </option>
                              <option className="form-control" value="Bible Study Class Teacher">
                                Bible Study Class Teacher
                              </option>
                              <option className="form-control" value="PCF Leader">
                                PCF Leader
                              </option>
                              <option className="form-control" value="Group Pastor">
                                Group Pastor
                              </option>
                              <option className="form-control" value="Graduate Pastor">
                                Graduate Pastor
                              </option>
                              <option className="form-control" value="Church Pastor">
                                Church Pastor
                              </option>
                              <option className="form-control" value="Senior Cell Leader">
                                Senior Cell Leader
                              </option>
                              <option className="form-control" value="Deaconry">Deaconry</option>
                            </select>
                            <span className="profile-views">
                              <i className="fas fa-users" />
                            </span>
                          </>
                        )}
                        defaultValue=""
                      />
                    </div>
                    <div className="form-group">
                      <label>
                        Have you been baptised?{" "}
                        <span className="login-danger">*</span>
                      </label>
                      <Controller
                              name="isBaptised"
                              control={control}
                              defaultValue="" // Default value for the Controller
                              render={({ field: { value, onChange } }) => (
                                <>
                                  <select
                                    className="form-control"
                                    value={value}
                                    onChange={onChange}
                                  >
                                    <option value="" disabled>
                                      Select an option
                                    </option>
                                    <option value={true}>Yes</option>
                                    <option value={false}>No</option>
                                  </select>
                                  <span className="profile-views">
                                    <i className="fas fa-users" />
                                  </span>
                                </>
                              )}
                            />
                            {errors?.isBaptised && (
                              <small className="text-danger">
                                {errors.isBaptised.message}
                              </small>
                            )}
                    </div>
                    <div className="form-group">
                      <label>
                        Password <span className="login-danger">*</span>
                      </label>
                      <Controller
                        name="password"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <div className="pass-group">
                            <input
                              type={passwordVisible ? "" : "password"}
                              className="form-control pass-input"
                              value={value}
                              onChange={onChange}
                            />
                            <span
                              className="toggle-password"
                              onClick={togglePasswordVisibility}
                            >
                              {passwordVisible ? (
                                <EyeOff className="react-feather-custom" />
                              ) : (
                                <Eye className="react-feather-custom" />
                              )}
                            </span>
                          </div>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.password?.message}</small>
                    </div>
                    <div className="form-group">
                      <label>
                        Confirm password <span className="login-danger">*</span>
                      </label>

                      <Controller
                        name="confirmPassword"
                        control={control}
                        render={({ field: { value, onChange } }) => (
                          <div className="pass-group">
                            <input
                              type={passwordVisible ? "" : "password"}
                              className="form-control pass-input"
                              value={value}
                              onChange={onChange}
                            />
                            <span
                              className="toggle-password"
                              onClick={togglePasswordVisibility}
                            >
                              {passwordVisible ? (
                                <EyeOff className="react-feather-custom" />
                              ) : (
                                <Eye className="react-feather-custom" />
                              )}
                            </span>
                          </div>
                        )}
                        defaultValue=""
                      />
                      <small>{errors?.confirmPassword?.message}</small>
                    </div>
                    <div className=" dont-have">
                      Already Registered? <Link to="/login">Login</Link>
                    </div>
                    <div className="form-group mb-0">
                      <button
                        className="btn btn-primary btn-block"
                        type="submit"
                        disabled={loading.active}
                      >
                        {!loading.active && "Register"}
                        {loading.active &&
                          loading.internalLoading &&
                          ".....loading"}
                      </button>
                    </div>
                  </form>
                  {/* /Form */}
                  {/* <div className="login-or">
                    <span className="or-line" />
                    <span className="span-or">or</span>
                  </div> */}
                  {/* Social Login */}
                  {/* <div className="social-login">
                    <Link to="#">
                      <i className="fab fa-google-plus-g" />
                    </Link>
                    <Link to="#">
                      <i className="fab fa-facebook-f" />
                    </Link>
                    <Link to="#">
                      <i className="fab fa-twitter" />
                    </Link>
                    <Link to="#">
                      <i className="fab fa-linkedin-in" />
                    </Link>
                  </div> */}
                  {/* /Social Login */}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default (props) => <Register {...hooks.authentication(props)} />;
